import React from 'react';
import AllClozeFeedback from '../../utils/feedback/allClozeFeedback';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	const {
		answerCount,
		rightFeedbackProps,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		answerCount,
		rightFeedbackProps,
		leftFeedbackProps,
	};
};

const WordCloudIncorrectFeedback = ({
	rightFeedbackProps: { correctAnswer, passage },
	leftFeedbackProps: { selectedAnswer },
}) => {
	//textCorrectAnswer = !!userAnswer && textCorrectAnswer.length>0 ? textCorrectAnswer : correctAnswer.split(' ')  ;

	return (
		<span>
			<h4 className="text-danger">That's incorrect</h4>

			<div className="quiz-area-answer">
				<div className="display-flex align-center">
					<div className="bord-right col-md-3">
						<h4 className="text-danger text-right">Your answer</h4>
					</div>
					<AllClozeFeedback
						correctAnswer={correctAnswer}
						selectedAnswer={selectedAnswer[0]}
						passage={passage}
					/>
				</div>
				<div className="display-flex align-center">
					<div className="bord-right col-md-3">
						<h4 className="text-success text-right">Correct answer</h4>
					</div>
					<div>
						<p className="pad-all mar-no">{correctAnswer}</p>
					</div>
				</div>
			</div>
		</span>
	);
};

export default connect(mapStateToProps)(WordCloudIncorrectFeedback);
